// extracted by mini-css-extract-plugin
module.exports = {"container":"Trend_container__3AvZ4","trends":"Trend_trends__3C3aE","head":"Trend_head__3CLW5"};